import { GetServerSideProps } from 'next'
import React from 'react'

import { Breadcrumbs } from '@Components/Breadcrumbs'
import { CMSPage } from '@Components/CMS/Page'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo/Server'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePost } from '@Queries/cms/SinglePost.query'

interface LookProps extends PageProps {
  item: Page
}

type Params = {
  id: string
  slug: string | string[]
}

export const getServerSideProps: GetServerSideProps<LookProps, Params> = async (context) => {
  const { params } = context
  if (!params?.id) {
    return {
      notFound: true,
    }
  }

  const url = new URL(context.req.url || '', 'http://localhost')

  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(
    apolloClient,
    PageType.Look,
    url.pathname,
    params.id,
    boostFromContext(context),
    context?.req?.thSplitTests,
  )
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }

  return {
    props: {
      ...await pageProps(
        context,
        {
          id: params.id,
          type: page.type,
        },
        page,
        ['common', 'cms', 'footer', 'header', 'sidebar', 'validation', 'shipping', 'giftcard', 'cart', 'products'],
      ),
      item: page as Page,
    },
  }
}

const Look = PageHOC<LookProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <CMSPage>
      <Breadcrumbs withMaxWidth />
      {components}
    </CMSPage>
  )
})

export default Look
